import React, { useState, useEffect, useRef } from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import * as bootstrap from 'bootstrap' // Make sure to install bootstrap: npm install bootstrap

const Faq = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const accordionRef = useRef(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch('https://evercorenutrition.com/ev_admin/api/faqs/');
        if (!response.ok) {
          throw new Error('Failed to fetch FAQs');
        }
        const data = await response.json();
        setFaqs(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  // Initialize Bootstrap accordion after FAQs are loaded
  useEffect(() => {
    if (!loading && faqs.length > 0) {
      // Initialize all collapse elements
      const collapseElements = document.querySelectorAll('.collapse');
      collapseElements.forEach((collapseEl) => {
        new bootstrap.Collapse(collapseEl, {
          toggle: false
        });
      });
    }
  }, [loading, faqs]);

  if (loading) {
    return (
      <>
        <Navbar />
        <section className="faq-box-contain section-b-space">
          <div className="container">
            <div className="loading-container" style={{ textAlign: 'center', padding: '50px' }}>
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p>Loading FAQs...</p>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar />
        <section className="faq-box-contain section-b-space">
          <div className="container">
            <div className="error-container" style={{ textAlign: 'center', padding: '50px' }}>
              <h2>Error</h2>
              <p>{error}</p>
              <button 
                className="btn btn-primary" 
                onClick={() => window.location.reload()}
              >
                Try Again
              </button>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      {/* <!-- Breadcrumb Section Start --> */}
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Frequently Asked Questions</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">FAQs</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Breadcrumb Section End --> */}

      {/* <!-- Faq Section Start --> */}
      <section className="faq-box-contain section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-xl-5">
              <div className="faq-contain">
                <h2>Frequently Asked Questions</h2>
                <p>We are answering most frequent questions. No worries if you not find exact one. You can contact us and ask.</p>
                <div className="Protein-faq">
                  <img src="/assets/images/Yeast_Protein.png" alt="Yeast Protein" style={{boxShadow:"1px 2px 12px #b5b5b5"}}/>
                </div>
              </div>
            </div>

            <div className="col-xl-7">
              <div className="faq-accordion">
                <div className="accordion" id="accordionExample" ref={accordionRef}>
                  {faqs.map((faq, index) => (
                    <div className="accordion-item" key={faq.id}>
                      <h2 className="accordion-header" id={`heading${faq.id}`}>
                        <button 
                          className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`} 
                          type="button" 
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${faq.id}`}
                          aria-expanded={index === 0 ? 'true' : 'false'}
                          aria-controls={`collapse${faq.id}`}
                        >
                          {faq.question}
                          <i className="fa-solid fa-angle-down"></i>
                        </button>
                      </h2>
                      <div 
                        id={`collapse${faq.id}`} 
                        className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                        aria-labelledby={`heading${faq.id}`}
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>{faq.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Faq Section End --> */}
      
      <Footer />
    </>
  )
}

export default Faq